export type Edge = { from_table: string; to_table: string }

export function computeDepths(edges: Edge[]) {
  const byFrom = new Map<string, Set<string>>()
  for (const e of edges) {
    if (!byFrom.has(e.from_table)) byFrom.set(e.from_table, new Set())
    byFrom.get(e.from_table)!.add(e.to_table)
  }

  const memo = new Map<string, number>()
  const visiting = new Set<string>()

  const depthOf = (table: string): number => {
    if (memo.has(table)) return memo.get(table)!
    if (visiting.has(table)) {
      // Cycle detected; treat as leaf to prevent infinite loop
      return 0
    }
    visiting.add(table)
    const tos = Array.from(byFrom.get(table) ?? [])
    let d = 0
    if (tos.length > 0) {
      d = 1 + Math.max(...tos.map((t) => depthOf(t)))
    }
    visiting.delete(table)
    memo.set(table, d)
    return d
  }

  return { depthOf }
}

export function depthOfFromEdges(edges: Edge[], table: string): number {
  return computeDepths(edges).depthOf(table)
}
